import { BaseWebComponentDataProvider } from '../../../../../framework/BaseWebComponentDataProvider';
import { ConsoleRequest, DataProviderType } from '../../../../../utils/request';
import { MdrMandatoryContactInformation } from '../../../../types/company-data';

export class ContactDetailsSectionDataProvider extends BaseWebComponentDataProvider {
  public async getCompanyMdrContactInformation(companyId: string): Promise<MdrMandatoryContactInformation | null> {
    return ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'Company',
      method: 'getCompanyMdrContactInformation',
      payload: {
        companyId,
      },
    });
  }
}
